import { type BoundActions, createActionsHook, type HookActionsFunction } from 'react-sweet-state';

import type { FeedbackStoreActions } from './FeedbackStoreActions';
import type { FeedbackStoreState } from './FeedbackStoreState';
import { store } from './store';

export const useFeedbackCollectorActions: HookActionsFunction<
	BoundActions<FeedbackStoreState, FeedbackStoreActions>
> = createActionsHook(store);
